// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","brand":"Footer_brand__InhVF","copy":"Footer_copy__nbk1i","links":"Footer_links__q2x7d","link":"Footer_link__MsGIJ"};